import { types as t } from 'mobx-state-tree';

import { defaultEditorValue } from '../../SlateObj/slate-editor.store';
import { BlankItem } from './blank-item.store';

export const AbstractWithBlank = t.model('AbstractWithBlank', {
  id: t.identifier,
  editorValue: t.optional(t.maybeNull<any>(t.string), defaultEditorValue),
  blanks: t.array(BlankItem),
  title: t.maybeNull<any>(t.string),
  doubleBranchIndex: t.maybeNull(t.number)
});
